<script lang="ts">
	import { beforeNavigate, onNavigate } from '$app/navigation';
	import { page, updated } from '$app/stores';
	import Actirise, { Mode } from '$lib/components/Actirise.svelte';
	import Analytics from '$lib/components/Analytics.svelte';
	import CMP from '$lib/components/CMP.svelte';
	import Content from '$lib/components/Content.svelte';
	import FacebookPixel from '$lib/components/FacebookPixel.svelte';
	import Footer from '$lib/components/Footer.svelte';
	import Navbar from '$lib/components/Navbar.svelte';
	import NewsletterBanner from '$lib/components/NewsletterBanner.svelte';
	import ProgressBar from '$lib/components/ProgressBar.svelte';
	import SEO from '$lib/components/SEO.svelte';
	import { isActirise } from '$lib/utils/PropertyMode';
	import '../app.css';
	import type { LayoutServerData } from './$types';

	export let data: LayoutServerData;

	const property = data.property;
	const colors = property.colors;

	onNavigate((navigation) => {
		if (!document.startViewTransition) {
			return;
		}

		return new Promise((resolve) => {
			document.startViewTransition(async () => {
				resolve();
				window.scrollTo(0, 0);
				await navigation.complete;
			});
		});
	});

	beforeNavigate(({ willUnload, to }) => {
		if ($updated && !willUnload && to?.url) {
			location.href = to.url.href;
		}
	});

	$: newsletter = data.newsletter;
</script>

<svelte:head>
	<title>{property.name}</title>
	<meta charset="utf-8" />
	<meta name="viewport" content="width=device-width, initial-scale=1" />
	<link rel="icon" href="/favicon.ico" sizes="32x32" />
	<link rel="icon" href="/icon.svg" type="image/svg+xml" />
	<link rel="apple-touch-icon" href="/apple-touch-icon.png" />
	<link rel="manifest" href="/manifest.webmanifest" />
	<link rel="alternate" type="application/rss+xml" href="https://{property.hostname}/rss.xml" />
	<meta name="robots" content="max-image-preview:large,index,follow" />
	<meta property="og:site_name" content={property.name} />
	<meta property="og:locale" content={property.locale} />
	<meta name="publisher" content={property.name} />
	{#each property.fbPages as page}
		<meta property="fb:pages" content={page} />
	{/each}
	<meta property="fb:app_id" content={property.fbApp} />
</svelte:head>

<SEO></SEO>

<CMP></CMP>

{#if isActirise(property)}
	<Actirise mode={Mode.INIT} />
{/if}

<FacebookPixel />
<Analytics id={property.analytics} />

<ProgressBar class={colors.text} zIndex={41} />

{#if newsletter}
	<NewsletterBanner />
{/if}

<Navbar />

{#if isActirise(property) && !$page.data?.explicit}
	<div data-actirise-slot="top-page" class="device-mobile device-tablet device-desktop ads"></div>
{/if}

<Content>
	<slot />
</Content>

<Footer />

<style lang="postcss">
	:global(body) {
		@apply overflow-y-scroll;
	}
</style>
